"use strict";

window.o_global = window.o_global || {};

o_global.device = o_global.device || {};

/**
 * Class for breakpoint handling.
 *
 * @class
 * @param {Object} breakpoints List of breakpoint-definitions: for example medium: window.matchMedia('(min-width: 28em)')
 */
function Breakpoint(breakpoints) {
    this.breakpoints = breakpoints;
    // Old (see line 132 usage):this._currentBreakpoint = this.getCurrentBreakpoint();
}

/**
 * Returns the breakpoint-list the class has been initialized with.
 *
 * @return {Object} A breakpoint list object
 */
Breakpoint.prototype.getBreakpoints = function() {
    return this.breakpoints;
};

/**
 * Is the current screen small as defined by the breakpoints?
 *
 * @return {Boolean} Value if the breakpoint is "small"
 */
Breakpoint.prototype.isSmall = function() {
    return this.breakpoints.small.matches;
};

/**
 * Is the current screen medium as defined by the breakpoints?
 *
 * @return {Boolean} Value if the breakpoint is "medium"
 */
Breakpoint.prototype.isMedium = function() {
    return this.breakpoints.medium.matches;
};

/**
 * Is the current screen large as defined by the breakpoints?
 *
 * @return {Boolean} Value if the breakpoint is "large"
 */
Breakpoint.prototype.isLarge = function() {
    return this.breakpoints.large.matches;
};

/**
 * Is the current screen extra large as defined by the breakpoints?
 *
 * @return {Boolean} Value if the breakpoint is "extra large"
 */
Breakpoint.prototype.isExtraLarge = function() {
    return this.breakpoints.extraLarge.matches;
};

/**
 * Returns the name of the active screen size as String: S, M, L or XL.
 *
 * @return {String} Name of the active screen size [S, M, L, XL]
 */
Breakpoint.prototype.getCurrentBreakpoint = function() {
    var result = "unknown";

    if (this.isSmall()) {
        result = "s";
    } else if (this.isMedium()) {
        result = "m";
    } else if (this.isLarge()) {
        result = "l";
    } else if (this.isExtraLarge()) {
        result = "xl";
    }

    return result;
};

/**
 * When passed an Array of breakpoint-names the function return true if one of them is currently active.
 *
 * @param {Array} breakpointList        Array of breakpoint-names, each as String: S, M, L or XL.
 *
 * @return {Boolean} Value if one of the passed breakpoints is active
 */
Breakpoint.prototype.isBreakpointActive = function(breakpointList) {
    var currentBreakpoint = this.getCurrentBreakpoint(),
        i;

    for (i = 0; i < breakpointList.length; i++) {
        if (breakpointList[i] === currentBreakpoint) {
            return true;
        }
    }

    return false;
};

/**
 * Registers a listener for breakpoint changes
 *
 * @param {Function} callback       Callback-function. When invoked it is passed
 * the name of the current breakpoint as String and the matchMedia-Object of the
 * breakpoint that has become either active or inactive.
 */
Breakpoint.prototype.registerChangeListener = function(callback) {
    // Uncomment for old revision: var that = this;
    var listenerWrapper = {
            "trigger": function(breakpoint) { // Function gets called for entering and leaving a breakpoint

                return function(breakpoints) {
                    if (breakpoints.matches) {
                        // Old revision: if (breakpoint !== that._currentBreakpoint) {
                        callback(breakpoint);
                        //}
                    }
                };
            }
        };

    this.breakpoints.small.addListener(listenerWrapper.trigger("s"));
    this.breakpoints.medium.addListener(listenerWrapper.trigger("m"));
    this.breakpoints.large.addListener(listenerWrapper.trigger("l"));
    this.breakpoints.extraLarge.addListener(listenerWrapper.trigger("xl"));
};

// Assign the Breakpoint class to o_global namespace.
o_global.breakpointClass = Breakpoint;

// Intialize a default object with the default breakpoints.
o_global.breakpoint = new o_global.breakpointClass({
    "small": window.matchMedia("(min-width: 0em) and (max-width: 27.99em)"),
    "medium": window.matchMedia("(min-width: 28em) and (max-width: 47.99em)"),
    "large": window.matchMedia("(min-width: 48em) and (max-width: 61.99em)"),
    "extraLarge": window.matchMedia("(min-width: 62em)")
});

o_global.device.breakpoint = o_global.breakpoint;
